import type { GridColDef } from "@mui/x-data-grid-premium";
import type { EntityFieldType, Field, ObjectWithFieldValuesBase } from "../../api/types/objectTypes";
import EntityValueGridCell from "./EntityValueGridCell";
import { fieldTypeToGridColTypeMap } from "./helpers";

// Email and Url cells render their own link (and copy button), so they must not be nested inside another anchor.
export const hasInteractiveGridCell = (fieldType: EntityFieldType): boolean =>
  fieldType === "Email" || fieldType === "Url";

export const getGridColumnForField = <R extends ObjectWithFieldValuesBase>(fieldDefinition: Field): GridColDef<R> => ({
  field: fieldDefinition.id,
  headerName: fieldDefinition.name,
  sortable: fieldDefinition.attributes.includes("Sortable"),
  flex: 1,
  type: fieldTypeToGridColTypeMap[fieldDefinition.type],
  renderCell: ({ row, field }) => {
    const entityFieldValue = row.fieldValues[field];
    if (entityFieldValue === undefined || entityFieldValue === null) {
      return null;
    }

    return (
      <EntityValueGridCell
        type={fieldDefinition.type}
        configuration={fieldDefinition.configuration}
        lookupObjectReferences={row.lookupObjects?.[field]}
        value={entityFieldValue}
      />
    );
  },
});
